import type { CharacterImageSources } from '@/lib/characters'

export interface GenericCharacter {
  /** Prefijo 'generic-' reservado al catálogo (predicados y rutas lo usan). */
  id: `generic-${string}`
  /** Kill-switch por personaje; debe coincidir con el config server (paridad). */
  enabled: boolean
  /**
   * Flag remota server-side que habilita el personaje por usuario. Sin valor,
   * `enabled` basta; con valor, la UI lo oculta hasta recibir `true` del
   * bootstrap autenticado y el endpoint de llamada vuelve a comprobarla.
   */
  featureFlag?: string
  /**
   * Orden de aparición en el catálogo (menor primero). La galería del dashboard
   * muestra los `FEATURED_GENERIC_LIMIT` de menor `order` y expande al resto con
   * "ver más"; el popup de selección los muestra todos.
   */
  order: number
  /** Nombre con el que se presenta (interpolado como {characterName} en la llamada). */
  displayName: string
  icon: string
  imageSources: CharacterImageSources
  /** Clip de la card del selector; sin él, la card cae al retrato estático. */
  previewVideoSrc?: string
}

/** Variantes `-card` optimizadas (368×560) por personaje; la UI nunca usa el hi-res. */
export function cardImageSources(id: `generic-${string}`): CharacterImageSources {
  return {
    webp: `/generic/${id}/${id}-card.webp`,
    src: `/generic/${id}/${id}-card.png`,
  }
}
